"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGeolocationData = void 0;
var _presentationUtils = require("@ori/presentation-utils");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _capitalize = _interopRequireDefault(require("es-toolkit/compat/capitalize"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _getCountryCode = require("./getCountryCode");
var _getHomeCountryUrl = require("./getHomeCountryUrl");
var _localStorageUtils = require("./localStorageUtils");
const formatCountryName = name => name.split(' ').map(_capitalize.default).join(' ');
/**
 * Fetches data needed to decide visibility of geolocation popup and data for homeCountry
 * (where user is according to countryCode) and foreignCountry (where user is NOT according to countryCode).
 * @param params - Parameters needed to fetch geolocation data.
 * @returns Promise with visibility and data for homeCountry and foreignCountry.
 */
const getGeolocationData = async ({
  enabled,
  isAnonymousUser,
  staticApiUrl,
  tenant,
  environment = 'live'
}) => {
  const countryCode = (0, _getCountryCode.getCountryCode)();
  if (!enabled || !isAnonymousUser || !countryCode || !tenant || countryCode === tenant) {
    return {
      foreignCountry: '',
      homeCountry: '',
      homeCountryUrl: '',
      visible: false
    };
  }
  const store = _jsCookie.default.get(_presentationUtils.PbsCookieNames.PBS_CODE) ?? _jsCookie.default.get(_presentationUtils.PbsCookieNames.PBS_OWNER);
  const hiddenByUser = (0, _localStorageUtils.getHiddenByUser)();
  if (!store || hiddenByUser) {
    return {
      foreignCountry: '',
      homeCountry: '',
      homeCountryUrl: '',
      visible: false
    };
  }
  const {
    language
  } = navigator;
  const client = new _staticApiClientReact.ApiClient({
    baseUrl: staticApiUrl,
    language,
    tenant
  });
  const [{
    data: {
      name: homeCountry = ''
    }
  }, {
    data: {
      isForeignRegistrationAllowed: visible,
      name: foreignCountry = ''
    }
  }] = await Promise.all([
  // We need to fetch translations with home country tenant (countryCode) to get correct translations.
  (0, _staticApiClientReact.getTenantCountry)(client, countryCode, countryCode, {
    lang: language
  }), (0, _staticApiClientReact.getTenantCountry)(client, countryCode, tenant, {
    lang: language
  })]);
  return {
    foreignCountry: formatCountryName(foreignCountry),
    homeCountry: formatCountryName(homeCountry),
    homeCountryUrl: (0, _getHomeCountryUrl.getHomeCountryUrl)({
      environment,
      store
    }),
    visible
  };
};
exports.getGeolocationData = getGeolocationData;